module.exports = function(router){
	router.map({
		'/':{
			name:'example',
			component: require('./views/example.vue')
		},
		'/basicinfo/:id':{
			name:'basicinfo',
			component:require('./views/basicinfo.vue')
		},
		'/newbasicinfo':{
			name:'newbasicinfo',
			component:require('./views/basicinfo.vue')
		},
		'/list':{
			name:'list',
			component:require('./views/list.vue')
		},
		'/aroundlist':{
			name:'aroundlist',
			component:require('./views/aroundList.vue')
		},
		'/guestroom/:id':{
			name:'guestroom',
			component:require('./views/guestroom.vue')
		},
		'/facilities/:id':{
			name:'facilities',
			component:require('./views/facilities.vue')
		},
		'/hotelAround/:id':{
			name:'hotelAround',
			component:require('./views/hotelAround.vue')
		},
		'/service/:id':{
			name:'service',
			component:require('./views/service.vue')
		},
		'/activity/:id':{
			name:'activity',
			component:require('./views/activity.vue')
		},
		'/stock/:id':{
			name: 'stock',
			component:require('./views/stock.vue')
		},
		// not found handler
	    '*': {
	      component: require('./views/not_found.vue')
	    }
	});


	window.routeList=[];
	router.beforeEach(function(transition){
		console.log('before---------------');
		//可以通过在路由中的自定义字段来验证用户是否需要登陆
		// if(transition.to.auth){
		// 	console.log('通过配置路由中自定义的字段验证是否需要登陆');
		// }

		// //如果是中止，这里可以判断用户登录
		// //if(transition.to.path === '/forbidden'){
		if(transition.to.name == 'forbidden'){

			router.app.authenticating = true
			setTimeout(function(){
				router.app.authenticating = false
				alert('此路由在全局中设置为中止');
				transition.abort();
			},1500);
		}

		if(routeList.length > 1 && transition.to.name==routeList[routeList.length-2]['name']){
			console.log('返回');

			router.app.effect='back';
			routeList.splice(routeList.length-1,1);
			console.log(routeList);
		} else {
			router.app.effect='fade';

			routeList.push({
				name : transition.to.name,
				path : transition.to.path,
				query : transition.to.query,
				params : transition.to.params,
				timer: +new Date
			});
		}

		//setTimeout(function(){
			transition.next();
		//},1000);
	});


	//可以记录访问路径 /back
	router.afterEach(function(transition){
		console.log('after');



		for (var i = 0; i < routeList.length; i++) {
			console.log(routeList[i].name);
		};

	});

}


//////////////////
// WEBPACK FOOTER
// ./src/routers.js
// module id = 61
// module chunks = 0